import { SelectMultiple } from '@bloomfieldrobotics/canopy';
import { useStages } from '../../../../services/entities/hooks/useStages';

type Props = {
  varietyId: string;
  value: string[];
  onChange: (value: string[]) => void;
};

export const StageSelect = ({ varietyId, value, onChange }: Props) => {
  const { stages } = useStages(varietyId);

  const options = stages.map((stage) => ({
    value: stage.id,
    label: stage.name,
  }));

  return (
    <SelectMultiple
      variant='minimal'
      options={options}
      value={value}
      onChange={onChange}
    />
  );
};
